import React, { useEffect, useState } from "react";

export const CarteraSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  return (
    <select
      className="select-cartera"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="C">Consolidada</option>
      <option value="V">Vencida</option>
      <option value="P">Por Vencer</option>
      {state.map((item) => (
        <option key={`cartera-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};